import BasicInformation from "./BasicInformation/BasicInformation";
import OwnHouse from "./OwnHouse/OwnHouse";

const Tab1 = ({
    handleLeftCalculations,
    handleExpensesSave,
    handleOwnHouseSave,
    mortgageStructureModal,
    handleMortgageStructureModal,
    taxBreakModal,
    handleTaxBreakModal,
    handleReportChangeSave,
}) => {
    
    return (
        <div>
            
            <BasicInformation handleLeftCalculations={handleLeftCalculations} handleReportChangeSave={handleReportChangeSave} />
            <OwnHouse
                handleLeftCalculations={handleLeftCalculations}
                handleExpensesSave={handleExpensesSave}
                handleOwnHouseSave={handleOwnHouseSave}
                mortgageStructureModal={mortgageStructureModal}
                handleMortgageStructureModal={handleMortgageStructureModal}
                taxBreakModal={taxBreakModal}
                handleTaxBreakModal={handleTaxBreakModal}
                handleReportChangeSave={handleReportChangeSave}
            />
        </div>
    );
};

export default Tab1;
